import { render, staticRenderFns } from "./PersonalLayout.vue?vue&type=template&id=5bff9d8a&scoped=true&"
import script from "./PersonalLayout.vue?vue&type=script&lang=js&"
export * from "./PersonalLayout.vue?vue&type=script&lang=js&"
import style0 from "./PersonalLayout.vue?vue&type=style&index=0&id=5bff9d8a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff9d8a",
  null
  
)

export default component.exports